export interface StripeCheckoutResponse {
  url?: string;      // present if redirect needed
  message?: string;  // present if direct update succeeded
}

// Example frontend call to create checkout session or update subscription
export async function createStripeCheckoutSession(tierId: string): Promise<StripeCheckoutResponse> {
  const response = await fetch("/api/stripe/create-checkout-session", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ tierId }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Failed to create session: ${errorText}`);
  }

  return response.json();
}
